import { ACTION_TYPES } from '../../actions/contractActions';

const INITIAL_STATE = {
  contractsList: [],

  contract: {
    plan_id: 10,
    crm_id: 20,
    is_active: 'True',
    max_device: 100,
    max_active: 50,
    plan_type: '1',
    day_debit: '01',
    client_id: 20,
    id: 231,
    // counter_device: 5,
    // counter_active: 1,
    // created_at: '2021-01-01 10:13:46',
    // updated_at: '2021-01-01 10:13:46',
    // activation_date: '2021-01-01 10:13:46',
    // deactivation_date: '2021-01-01 10:13:46',
  },

  loadMore: true,
};

const ContractsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_CONTRACTS_LIST:
      return { ...state, contractsList: [...state.contractsList, ...action.contracts_data] };

    case ACTION_TYPES.ENABLE_LOAD_MORE:
      return { ...state, loadMore: action.value };

    case ACTION_TYPES.CLEAR_CONTRACTS_LIST:
      return { ...state, contractints: [] };

    default:
      return state;
  }
};

export default ContractsReducer;
